import { render, staticRenderFns } from "./AutoSelect.vue?vue&type=template&id=35c7c552&"
import script from "./AutoSelect.vue?vue&type=script&lang=js&"
export * from "./AutoSelect.vue?vue&type=script&lang=js&"
import style0 from "./AutoSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
